import { https, httpsMultipart } from 'shared/utils/https';
import type {
  IGetNavigationPriceGroupsResponse,
  IGetNavigationTreeListResponse,
  IGetNavigationTreeParams,
  INavigationTreeListItemResponse,
} from './navigation.dto';

const treesPath = '/v1/navigations';

export const navigationData = {
  getNavigationTrees: async (params: IGetNavigationTreeParams): Promise<IGetNavigationTreeListResponse> => {
    const { data } = await https.get<IGetNavigationTreeListResponse>(treesPath, {
      params,
    });

    return data;
  },

  getNavigationPriceGroups: async (navigationId?: number): Promise<IGetNavigationPriceGroupsResponse> => {
    const { data } = await https.get<IGetNavigationPriceGroupsResponse>(`${treesPath}/price-groups`, {
      params: { onlyAvailable: true, navigationId },
    });
    return data;
  },

  getNavigationTreeDetailById: async (id: number): Promise<INavigationTreeListItemResponse> => {
    const response = await https.get<INavigationTreeListItemResponse>(`${treesPath}/${id}`);
    return response.data;
  },

  createNavigationTree: async (body: FormData) => {
    await httpsMultipart.post(treesPath, body);
  },

  editNavigationTree: async (id: number, body: FormData): Promise<void> => {
    await httpsMultipart.patch<void>(`${treesPath}/${id}`, body);
  },

  deleteNavigationTree: async (id: number): Promise<void> => {
    await https.delete<void>(`${treesPath}/${id}`);
  },

  duplicateNavigationTree: async (body: FormData): Promise<number> => {
    const { data } = await httpsMultipart.post<{ id: number }>(`${treesPath}`, body);
    return data.id;
  },
};
